import { render, staticRenderFns } from "./ContentWamp.vue?vue&type=template&id=d8cb7824&"
import script from "./ContentWamp.vue?vue&type=script&lang=js&"
export * from "./ContentWamp.vue?vue&type=script&lang=js&"
import style0 from "./ContentWamp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports